import Store from "../Store";
import AppStore from "../AppStore";
import { runInAction, toJS } from "mobx";
import ValueRating, {
  IValueRating,
} from "../../models/three-sixty-feedback-models/ValueRating";

export default class ValueRatingStore extends Store<IValueRating, ValueRating> {
  items = new Map<string, ValueRating>();

  constructor(store: AppStore) {
    super(store);
    this.store = store;
  }

  load(items: IValueRating[] = []) {
    runInAction(() => {
      items.forEach((item) => {
        this.items.set(item.id, new ValueRating(this.store, item));
      });
    });
  }
  getByUid(uid: string) {
    const all = Array.from(this.items.values());
    return all.filter((item) => item.asJson.id === uid);
  }

  get allMe() {
    const me = this.store.auth.meJson;
    if (!me) return [];
    return this.getByUid(me.uid);
  }

  get all() {
    return Array.from(toJS(this.items.values()));
  }
}
